import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  @ViewChild('top', { static: false }) topEl: ElementRef
  @ViewChild('products', { static: false }) productsEl: ElementRef
  @ViewChild('team', { static: false }) teamEl: ElementRef
  @ViewChild('gallery', { static: false }) galleryEl: ElementRef
  @ViewChild('contact', { static: false }) concactEl: ElementRef
  @ViewChild('hours', { static: false }) hoursEl: ElementRef
  @ViewChild('about', { static: false }) aboutEl: ElementRef
  @ViewChild('location', { static: false }) locationEl: ElementRef

  @ViewChild('menu') navMenu: ElementRef
  @ViewChild('other') hiddenLayer: ElementRef
  constructor(private title: Title, private meta: Meta) { }

  ngOnInit(): void {
    this.title.setTitle("Barbershop Denim — Men's Barbershop on South Street, Philadelphia");
    this.meta.updateTag({
      name: 'description',
      content: "Barbershop Denim is a men's barbershop at 1517 South Street in Center City, Philadelphia. Walk-ins welcome and online booking available — a short walk from Rittenhouse Square and South Philadelphia.",
    });
    this.meta.updateTag({ name: 'robots', content: 'index, follow, max-image-preview:large' });
  }

  triggerScroll(elementName: string) {
    let element: ElementRef
    switch (elementName) {
      case 'team':
        element = this.teamEl
        break;
      case 'products':
        element = this.productsEl
        break;
      case 'gallery':
        element = this.galleryEl
        break;
      case 'contact':
        element = this.concactEl
        break;
      case 'hours':
        element = this.hoursEl
        break;
      case 'about':
        element = this.aboutEl
        break;
      case 'location':
        element = this.locationEl
        break;
    }
    element.nativeElement.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
  }

  onOpen() {
    this.navMenu.nativeElement.style.width = "500px";
    this.hiddenLayer.nativeElement.style.zIndex = "500"
    this.hiddenLayer.nativeElement.style.backgroundColor = "rgba(0,0,0,.5)"
  }

  onClose() {
    this.navMenu.nativeElement.style.width = 0;
    this.hiddenLayer.nativeElement.style.zIndex = 0
    this.hiddenLayer.nativeElement.style.backgroundColor = "rgba(0,0,0,0)"
  }

  onNavigate(elementId: string) {
    this.onClose()
    this.triggerScroll(elementId)
  }
}
